import { render } from "./SearchWifi.vue?vue&type=template&id=8827f036&scoped=true"
import script from "./SearchWifi.vue?vue&type=script&lang=js"
export * from "./SearchWifi.vue?vue&type=script&lang=js"

import "./SearchWifi.vue?vue&type=style&index=0&id=8827f036&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8827f036"]])

export default __exports__